import { render, staticRenderFns } from "./SchemeDetail.vue?vue&type=template&id=1083d1f3&"
import script from "./SchemeDetail.vue?vue&type=script&lang=js&"
export * from "./SchemeDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchemeDetail.vue?vue&type=style&index=0&id=1083d1f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports